import * as React from 'react';
import { CircularProgress } from '@mui/material';
import classes from './KeycloakLoader.module.scss';

export const KeycloakLoader = () => {
  return (
    <section className={classes.preloader}>
      <h1>Profile loading...</h1>
      <CircularProgress />
    </section>
  );
};